// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindDynamicNumber } from "../schema";

export function serialize_KindDynamicNumber_internal(value: KindDynamicNumber): unknown {
  return ((value: "dynamicNumber"): unknown => {
    return value;
  })(value);
}
export function serialize_KindDynamicNumber(obj: KindDynamicNumber): string {
  return renderJsonWithNumbersAsBigint(serialize_KindDynamicNumber_internal(obj));
}
export function deserialize_KindDynamicNumber_internal(value: unknown): ParserResult<KindDynamicNumber> {
  return ((value: unknown): ParserResult<"dynamicNumber"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "dynamicNumber":
        return { success: true, value: "dynamicNumber" };
      default:
        return { success: false, reason: `[#/components/schemas/KindDynamicNumber]: '${value}' expected to be enum, one of 'dynamicNumber'.` };
    }
  })(value);
}
export function deserialize_KindDynamicNumber(str: string): ParserResult<KindDynamicNumber> {
  return deserialize_KindDynamicNumber_internal(parseJsonWithNumbersAsBigint(str));
}
